import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContactUsContent from './ContactUsContent';

function ContactUs({ builder, page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <ContactUsContent
        builder={builder}
        page={page}
      />
    </PageWrapper>
  );
}

ContactUs.propTypes = {
  builder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  page: 'contact_us',
})(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js